import ModalAddEditRight from "./modal-add-edit-right";

export default ModalAddEditRight;